import { ErrorTypeEnum } from "./types";
import * as React from "react";
import {
  AlertBanner,
  Box,
  Text,
  TextLink,
  AlertBannerProps,
} from "@origin-digital/ods-core";
import { pageHeaderHeight, pageHeaderZIndex } from "src/constants";

interface IErrorBannerProps {
  errorType: ErrorTypeEnum | null;
  onClose: React.Dispatch<React.SetStateAction<ErrorTypeEnum | null>>;
  alertBannerProps?: Partial<AlertBannerProps>;
}

const ErrorBanner = ({
  errorType,
  onClose,
  alertBannerProps,
}: IErrorBannerProps) => {
  switch (errorType) {
    case ErrorTypeEnum.OCP_FIELD_VALIDATION:
      return (
        <FixedWrapper>
          <AlertBanner
            tone="critical"
            title="Invalid or missing fields"
            fluidity={true}
            offset={56}
            onCloseClick={() => onClose(null)}
            {...alertBannerProps}
          >
            <Text>
              Mandatory field missed or invalid data in field. Please fix where
              highlighted and try again.
            </Text>
          </AlertBanner>
        </FixedWrapper>
      );
    case ErrorTypeEnum.KRAKEN_FIELD_VALIDATION:
      return (
        <FixedWrapper>
          <AlertBanner
            tone="caution"
            title="Request needs review"
            fluidity={true}
            offset={56}
            onCloseClick={() => onClose(null)}
            {...alertBannerProps}
          >
            <Text>
              Once the review is complete, we'll update your request in Origin
              Connect where you can track its progress. You can email us at{" "}
              <TextLink href={"mailto:NCOrigin@originenergy.com.au"}>
                NCOrigin@originenergy.com.au
              </TextLink>{" "}
              for more information.
            </Text>
          </AlertBanner>
        </FixedWrapper>
      );
    case ErrorTypeEnum.KRAKEN_TIMEOUT:
      return (
        <FixedWrapper>
          <AlertBanner
            tone="critical"
            title="Request not lodged"
            fluidity={true}
            offset={56}
            onCloseClick={() => onClose(null)}
            {...alertBannerProps}
          >
            <Text>
              Your request has been saved as a draft so you can try to lodge it
              later.
            </Text>
          </AlertBanner>
        </FixedWrapper>
      );
    default:
      return null;
  }
};

const FixedWrapper = ({ children }: { children: React.ReactNode }) => (
  <Box
    style={{
      position: "fixed",
      top: pageHeaderHeight,
      left: 0,
      right: 0,
      zIndex: pageHeaderZIndex,
    }}
  >
    {children}
  </Box>
);

export default ErrorBanner;
